/**
 * @typedef {'collapse' | 'expand'} AccordionTranslationKeys
 * @typedef {'element_not_found' | 'error_generating_image' | 'preparing_download' | 'loading'} CaptureTranslationKeys
 * @typedef {'Nera_atsakymu' | 'rezultataiRezultatai'} ResultsTranslationKeys
 */

/**
 * @type {Object.<string, string>}
 */
export const TRANSLATION_KEYS = {
    COLLAPSE: 'collapse',
    EXPAND: 'expand',
    ELEMENT_NOT_FOUND: 'element_not_found',
    ERROR_GENERATING_IMAGE: 'error_generating_image',
    PREPARING_DOWNLOAD: 'preparing_download',
    LOADING: 'loading',
    NO_ANSWERS: 'Nera_atsakymu',
    RESULTS: 'rezultataiRezultatai'
};

export const ACCORDION_TRANSLATIONS = {
    collapse: 'collapse',
    expand: 'expand'
};

export const CAPTURE_TRANSLATIONS = {
    element_not_found: 'element_not_found',
    error_generating_image: 'error_generating_image',
    preparing_download: 'preparing_download',
    loading: 'loading'
};

export const RESULTS_TRANSLATIONS = {
    no_answers: 'Nera_atsakymu',
    results: 'rezultataiRezultatai'
};

/**
 * Ensures a translation key exists in our translations
 * @param {string} key The translation key to validate
 * @param {Object} translationGroup The group of valid translations to check against
 * @returns {boolean} Whether the key is valid
 */
export const validateTranslationKey = (key, translationGroup) => {
    return Object.values(translationGroup).includes(key);
};
